import { render, staticRenderFns } from "./commonPiker.vue?vue&type=template&id=4240d8aa&scoped=true&"
import script from "./commonPiker.vue?vue&type=script&lang=js&"
export * from "./commonPiker.vue?vue&type=script&lang=js&"
import style0 from "./commonPiker.vue?vue&type=style&index=0&id=4240d8aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240d8aa",
  null
  
)

export default component.exports